import YGCClassPage from "./YGCClassPage";
export default function Ygc2020() {
  return <YGCClassPage year="2020" wip={true} />;
}